import { AxiosResponse } from 'axios';
import root from '../root';

export async function fetchConstants(): Promise<AxiosResponse<any>> {
  return await root({
    url: '/constants',
  });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/api/constant/constant.ts